import {  isPending, loadPromise, getKeycloak } from '@/config/keycloak';
import { defineStore } from 'pinia'
import getConfig from '@/config/app-config'

export const useUserStore = defineStore('user', {
  state: () => ({
    username: "",
    lastUpdate: 0,
    minRefresh: 100000000,
    placement: "Secretaria de Informática",
    admin: false,
    drawerExpanded: false
  }),
  getters: {
    user() {
      this.fetch();
      return this.username;
    }

  },

  actions: {
    async fetch() {
      const installUserFetchHook = () => {
        if (getKeycloak().onAuthSuccess?._userFetchHookInstalled) return;
        const originalHook = getKeycloak().onAuthSuccess;
        getKeycloak().onAuthSuccess = typeof originalHook == 'function' ? () => { originalHook(); this.fetch() } : () => (this.fetch())
        getKeycloak().onAuthSuccess._userFetchHookInstalled = true
        console.log(getKeycloak())
      }
      if (isPending) await loadPromise
      if (!getKeycloak()?.authenticated) {
        installUserFetchHook()
        return
      }
      return await (async () => {
        let data = ""
        try {
          if ((new Date()).getTime() - this.lastUpdate < this.minRefresh) return
          
          console.log(getKeycloak()?.tokenParsed)
          this.admin = getKeycloak()?.tokenParsed?.realm_access?.roles?.includes(getConfig()?.sso['admin-role']) || false;
          this.username = getKeycloak()?.tokenParsed?.preferred_username || "";

          this.lastUpdate = (new Date()).getTime();
        } catch (e) {
          console.warn(e)
        }
        return data.data
      })()
    },
    async logout() {
      getKeycloak().logout()
    }
  },
})
